import React from 'react';
import { InputLabelContainer } from '../../../../../common/components/form/label/containers/input-label.container';
import { format } from '../../../../../common/services/common.service';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import _ from 'lodash';
import { HiOutlineTrash } from 'react-icons/hi';
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../redux/library/selector';
const ScheduledTaskBasicInfoComponent = ({scheduledTasks, handleInnerFormChange,
  handleFormItemChange,
  deleteSelectedService,
  scheduleCommands,
  handleInnerBasicFormChange,
  id
 }:any) => {

const libraryData = useSelector(selectListItems)

  return (
    <>
    {id > 0 &&
    <AccordionContainer
                   child={
                     <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                       <div>
                        <InputLabelContainer
                                  label="Name"
                              />
                              {scheduledTasks?.Name}
                        </div>  
                       
                        <InputContainer
                          label="Days"
                          name="DHMS.Days"
                          onValueChange={(event:any) => handleInnerFormChange(
                            event.target.value,
                            'DHMS.Days',
                            scheduledTasks?.DHMS
                          )}
                          type="number"
                          value={scheduledTasks?.DHMS?.Days}
                        />
                        <InputContainer
                        label="Hours"
                          name="DHMS.Hours"
                          onValueChange={(event:any) => handleInnerFormChange(
                            event.target.value,
                            'DHMS.Hours',
                            scheduledTasks?.DHMS
                          )}
                          type="number"
                          value={scheduledTasks?.DHMS?.Hours}
                        />
                       
                        <InputContainer
                         label="Minutes"
                          name="DHMS.Minutes"
                          onValueChange={(event:any) => handleInnerFormChange(
                            event.target.value,
                            'DHMS.Minutes',
                            scheduledTasks?.DHMS
                          )}
                          type="number"
                          value={scheduledTasks?.DHMS?.Minutes}
                        />
                         <InputContainer
                        label="Seconds"
                          name="DHMS.Seconds"
                          onValueChange={(event:any) => handleInnerFormChange(
                            event.target.value,
                            'DHMS.Seconds',
                            scheduledTasks?.DHMS
                          )}
                          type="number"
                          value={scheduledTasks?.DHMS?.Seconds}
                        />
                        <div>
                        <InputLabelContainer
                                  label="Last Start Date"
                              />
                               <InputLabelContainer label={format(scheduledTasks?.LastStartUtc)} />
                        </div>  
                         <div>
                        <InputLabelContainer
                                  label="Last End Date"
                              />
                              <InputLabelContainer label={format(scheduledTasks?.LastEndUtc)} />
                        </div>  
                        <div>
                        <InputLabelContainer
                                  label="Last Success Date"
                              />
                                <InputLabelContainer label={format(scheduledTasks?.LastSuccessUtc)} />
                        </div>  
                     </div>
                   }
                   expandedPanel="BasicInfo"
                   headerTitle="Basic Information"
                 />
                  }




                  {id == 0 &&
    <AccordionContainer
                   child={
                     <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Name"
              labelField="Name"
              onValueChange={(event: any, newValue: any) => {
                handleInnerBasicFormChange(
                  event.target.value,
                  'Name'
                );
              } }
              type="text"
              value={scheduledTasks?.Name} />

            <InputContainer
              label="Days"
              name="DHMS.Days"
              onValueChange={(event: any) => handleInnerFormChange(
                event.target.value,
                'DHMS.Days',
                scheduledTasks?.DHMS
              )}
              type="number"
              value={scheduledTasks?.DHMS?.Days} />
            <InputContainer
              label="Hours"
              name="DHMS.Hours"
              onValueChange={(event: any) => handleInnerFormChange(
                event.target.value,
                'DHMS.Hours',
                scheduledTasks?.DHMS
              )}
              type="number"
              value={scheduledTasks?.DHMS?.Hours} />
            <InputContainer
              label="Minutes"
              name="DHMS.Minutes"
              onValueChange={(event: any) => handleInnerFormChange(
                event.target.value,
                'DHMS.Minutes',
                scheduledTasks?.DHMS
              )}
              type="number"
              value={scheduledTasks?.DHMS?.Minutes} />
            <InputContainer
              label="Seconds"
              name="DHMS.Seconds"
              onValueChange={(event: any) => handleInnerFormChange(
                event.target.value,
                'DHMS.Seconds',
                scheduledTasks?.DHMS
              )}
              type="number"
              value={scheduledTasks?.DHMS?.Seconds} />
            <InputContainer
              label="Last Start Date"
              labelField="LastStartUtc"
              onValueChange={(event: any, newValue: any) => {
                handleInnerBasicFormChange(
                  event.target.value,
                  'LastStartUtc'
                );
              } }
              type="date"
              value={scheduledTasks?.LastStartUtc} />
            <InputContainer
              label="Last End Date"
              labelField="LastEndUtc"
              onValueChange={(event: any, newValue: any) => {
                handleInnerBasicFormChange(
                  event.target.value,
                  'LastEndUtc'
                );
              } }
              type="date"
              value={scheduledTasks?.LastEndUtc} />
            <InputContainer
              label="Last Success Date"
              labelField="LastSuccessUtc"
              onValueChange={(event: any, newValue: any) => {
                handleInnerBasicFormChange(
                  event.target.value,
                  'LastSuccessUtc'
                );
              } }
              type="date"
              value={scheduledTasks?.LastSuccessUtc} />
            </div>
            
          }
                   expandedPanel="BasicInfo"
                   headerTitle="Basic Information"
                 />
                  }


  <AccordionContainer
    child={
      <div className="h-[500px] overflow-auto w-full bg-white p-4">
        <table className="w-full text-xs bg-red-50">
          <thead className="w-full border-y border-black border-opacity-20 border-b">
            <tr className="w-full text-left h-12">
              <th className="border-r-2 last:border-r-0 w-auto px-10">Command</th>
              <th className="border-r-2 last:border-r-0 w-auto px-10">Command Type</th>
              <th className="border-r-2 last:border-r-0 w-auto px-10">Instruction</th>
              <th className="border-r-2 last:border-r-0 w-auto px-10">Display Order</th>
            </tr>
          </thead>
          <tbody className="w-full bg-red-400 h-[100px]">
            {_.map(scheduleCommands, (cardValue: any, index: any) => (
              <tr key={index} className={`${index % 2 === 0 ? 'bg-blue-100' : 'bg-white'}`}>
                <td className="px-6 py-4 w-auto">
                  <InputContainer
                    name="Command"
                    onValueChange={(event: any) => {
                      handleFormItemChange({
                        value: event.target.value,
                        field: 'Command',
                        idx: index
                      });
                    }}
                    type="text"
                    value={cardValue?.Command}
                  />
                </td>
                <td className="px-6 py-4 w-auto">
                  <InputContainer
                    labelField="Text"
                    list={libraryData.result.ScheduleCommandType}
                    onValueChange={(event: any) => {
                      handleFormItemChange({
                        value: event.target.value,
                        field: 'ScheduleCommandTypeId',
                        idx: index
                      });
                    }}
                    optionName="Choose Command Type"
                    type="select"
                    value={cardValue?.ScheduleCommandTypeId}
                    valueField="Value"
                  />
                </td>
                <td className="px-6 py-4 w-auto">
                  <InputContainer
                    name="Instruction"
                    onValueChange={(event: any) => {
                      handleFormItemChange({
                        value: event.target.value,
                        field: 'Instruction',
                        idx: index
                      });
                    }}
                    type="text"
                    value={cardValue?.Instruction}
                  />
                </td>
                <td className="px-6 py-4 w-auto">
                  <InputContainer
                    name="Display Order"
                    onValueChange={(event: any) => {
                      handleFormItemChange({
                        value: event.target.value,
                        field: 'DisplayOrder',
                        idx: index
                      });
                    }}
                    type="number"
                    value={cardValue?.DisplayOrder}
                  />
                </td>
                <td key={9} className="flex px-5 w-max flex-row justify-start item-baseline cursor-pointer pt-6 space-x-2">
                  <button className="text-red-500 hover:text-red-700" onClick={() => deleteSelectedService(cardValue, index)}>
                    <HiOutlineTrash className="w-6 h-6" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    }
    expandedPanel="Scheduled Command Info"
    headerTitle="Scheduled Command Info"
  />

        </>      
  );
};

export default ScheduledTaskBasicInfoComponent;